import { Button, ButtonProps, LinkProps } from '@chakra-ui/react'
import { NextLinkProps } from '@src/components/sco/utilities/NextLink'
import NextLink from 'next/link'
import { forwardRef } from 'react'

export type ButtonLinkProps = ButtonProps & LinkProps

export const ButtonLink = forwardRef<HTMLAnchorElement, ButtonLinkProps>((props, ref) => {
  return (
    <Button asChild={true} {...props}>
      <NextLink ref={ref} {...(props as NextLinkProps)} />
    </Button>
  )
})

ButtonLink.displayName = 'ButtonLink'
